import Types from "./types";
import { CatalogGatewayService } from "../../../service/catalog-gateway";
import { updateCarListForNonServiceable } from "../car-list/actions";

const getServiceabilityCheckInit = () => ({
    type: Types.FETCH_SERVICEABILITY_CHECK
});
const getServiceabilityCheckSuccess = (data) => ({
    type: Types.FETCH_SERVICEABILITY_CHECK_SUCCESS,
    data
});

const getServiceabilityCheckFailure = (error) => ({
    type: Types.FETCH_SERVICEABILITY_CHECK_FAILURE,
    error
});

const getServiceabilityCheck = (cityId) => (dispatch) => {
    dispatch(getServiceabilityCheckInit());
    return new Promise((resolve, reject) => {
        CatalogGatewayService.getServiceability(cityId, {source: "WebApp"})
            .then(response => {
                dispatch(getServiceabilityCheckSuccess(response.data));
                resolve(response.data);
            }).catch(error => {
                dispatch(getServiceabilityCheckFailure(error));
                reject(error);
            });

    });
};
const fetchNearByCarsListSuccess = (data) => ({
    type: Types.FETCH_NEAR_BY_CARS_LIST_SUCCESS,
    data
});
const setSelectedNearByCity = (data) => ({
    type: Types.SET_SELECTED_NEAR_BY_CITY,
    data
});

const fetchNearByCarsListInit = () => ({
    type: Types.FETCH_NEAR_BY_CARS_LIST
});

const fetchNearByCarsListFailure = (error) => ({ type: Types.FETCH_NEAR_BY_CARS_LIST_FAILURE, error });

const fetchNearByCarsList = (payload) => (dispatch) => {
    dispatch(fetchNearByCarsListInit());
    return new Promise((resolve, reject) => {
        CatalogGatewayService.getNearByCarlist(payload, {source: "WebApp"})
            .then(response => {
                dispatch(fetchNearByCarsListSuccess(response.data));
                dispatch(updateCarListForNonServiceable(response.data));
                resolve(response.data);
            }).catch(error => {
                dispatch(fetchNearByCarsListFailure(error));
                reject(error);
            });
    });
};
const setIsServiceableLoading = (data) => ({
    type: Types.SET_IS_SERVICEABLE_LOADING,
    data
});
const updateSSRStatus = (isSSrServiceable) => ({
    type: Types.UPDATE_SSR_STATUS,
    isSSrServiceable
});

const resetNearByCitiesData = () => ({
    type: Types.RESET_NEAR_BY_CITIES
});

export {
    getServiceabilityCheck,
    fetchNearByCarsList,
    setSelectedNearByCity,
    setIsServiceableLoading,
    updateSSRStatus,
    resetNearByCitiesData
};
